import { BranchEventAction } from '@pages/Authorized/Branch/EventPage'

import PageTitle, { PageTitleAction } from '@components/molecules/PageTitle'

type Props = {
  onAction: (type: BranchEventAction) => void
}

export default function BranchEventTitle({ onAction }: Props): JSX.Element {
  const actions: PageTitleAction[] = [{ label: '이벤트 추가', buttonType: 'primary', onClick: () => onAction('add') }]

  return <PageTitle title="이벤트" actions={actions} />
}
